(function () {
  if (customElements.get('td-reviews-preview')) {
    return;
  }

  class TdReviewsPreview extends HTMLElement {
    #filter = 'all';
    #dotWindow = 5;

    connectedCallback() {
      this.carousel = this.querySelector('scroll-carousel');
      this.pagination = this.querySelector('carousel-navigation');

      this.querySelectorAll('[data-reviews-filter]').forEach((button) => {
        button.addEventListener('click', () => {
          const filter = button.getAttribute('data-reviews-filter');
          if (!filter) {
            return;
          }
          this.applyFilter(filter);
        });
      });

      this.carousel?.addEventListener('carousel:change', (event) => {
        this.syncPaginationVisibility(event.detail?.index);
      });
      this.syncPaginationVisibility(0);
    }

    getSlides() {
      return [...this.querySelectorAll('.td-reviews-preview__slide')];
    }

    slideTags(slide) {
      const raw = slide.getAttribute('data-tags') || '';
      if (!raw) {
        return [];
      }

      return raw.split('|').map((tag) => tag.trim()).filter(Boolean);
    }

    slideMatches(slide) {
      if (this.#filter === 'all') {
        return true;
      }

      return this.slideTags(slide).includes(this.#filter);
    }

    applyFilter(filter) {
      this.#filter = filter;

      this.querySelectorAll('[data-reviews-filter]').forEach((button) => {
        button.setAttribute(
          'aria-pressed',
          button.getAttribute('data-reviews-filter') === filter ? 'true' : 'false'
        );
      });

      const slides = this.getSlides();

      slides.forEach((slide) => {
        const visible = this.slideMatches(slide);
        slide.toggleAttribute('hidden', !visible);
      });

      this.announceShownCount();
      this.syncPaginationVisibility(0);

      if (typeof this.carousel?.select === 'function' && this.carousel.cells.length > 0) {
        this.carousel.select(0, { instant: true });
      }
    }

    announceShownCount() {
      const live = document.getElementById('status-announcement');
      if (!live) {
        return;
      }

      const shown = this.querySelectorAll('.td-reviews-preview__slide:not([hidden])').length;
      const message = `${shown} ${shown === 1 ? 'review' : 'reviews'} shown`;
      live.textContent = '';
      setTimeout(() => {
        live.textContent = message;
      }, 100);
    }

    syncPaginationVisibility(activeVisibleIndex) {
      if (!this.pagination) {
        return;
      }

      const slides = this.getSlides();
      const dots = [...this.pagination.querySelectorAll('button')];
      const visibleDots = [];

      dots.forEach((dot, index) => {
        const slide = slides[index];
        const visible = Boolean(slide && this.slideMatches(slide));
        dot.hidden = !visible;
        dot.classList.remove('is-outside-window');
        if (visible) {
          visibleDots.push(dot);
        }
      });

      if (visibleDots.length <= this.#dotWindow) {
        return;
      }

      let active = Number.isInteger(activeVisibleIndex) ? activeVisibleIndex : 0;
      if (active < 0 || active >= visibleDots.length) {
        active = 0;
      }

      let start = active - Math.floor(this.#dotWindow / 2);
      start = Math.max(0, Math.min(start, visibleDots.length - this.#dotWindow));

      visibleDots.forEach((dot, index) => {
        dot.classList.toggle('is-outside-window', index < start || index >= start + this.#dotWindow);
      });
    }
  }

  customElements.define('td-reviews-preview', TdReviewsPreview);
})();
